import React from "react";
import { useDisclosures } from "./useDisclosures";
import "./Disclosures.scss";

interface DisclosureFormProps {
  disclosureId: string;
  financialApplicationId: string;
}

export const DisclosureForm: React.FC<DisclosureFormProps> = ({
  disclosureId,
  financialApplicationId,
}) => {
  const { getDisclosure, error } = useDisclosures(financialApplicationId);

  const disclosure = getDisclosure(disclosureId);

  if (!disclosure) {
    return (
      <section className="disclosures-info step-section">
        <div className="disclosures-info__header step-header">Disclosure Not Found</div>
      </section>
    );
  }

  return (
    <section className="disclosures-info step-section">
      <div className="disclosures-info__header step-header">
        Document Review and Acknowledgement
      </div>
      <div className="disclosures-info__subtitle step-subtitle">{disclosure.label}</div>

      {error && <div className="disclosures-info__error">{error}</div>}

      <div className="disclosures-info__document">
        <object
          width="100%"
          height="100%"
          key={disclosure.id?.toString()}
          data={`${disclosure.fileUrl}#zoom=75`}
          type="application/pdf"
        ></object>
      </div>
    </section>
  );
};
